import { Avatar } from 'antd';
import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';

import { ICustomGatsbyImageData } from '@sorpetaler/ui/src/utils/types';
import { ContentfulImage } from '@sorpetaler/ui/src/components/ContentfulImage';

import * as styles from './WidgetFormQuote.module.less';

export const WidgetFormQuote: React.FunctionComponent = () => {
  const data = useStaticQuery<{
    contentfulAsset: ICustomGatsbyImageData | null;
  }>(graphql`
    query WidgetFormQuoteQuery {
      contentfulAsset(contentful_id: { eq: "1YUfoPGQoI31EcXTOEq2yv" }) {
        title
        description
        gatsbyImageData(
          width: 102
          placeholder: BLURRED
          layout: CONSTRAINED
          breakpoints: [59, 90, 102, 118, 180, 204]
        )
      }
    }
  `);

  const ceoImage = data.contentfulAsset || undefined;

  return (
    <div className={styles.container}>
      <div>
        <Avatar
          size={{ xs: 59, sm: 59, md: 90, lg: 102, xl: 102, xxl: 102 }}
          src={
            ceoImage ? (
              <ContentfulImage
                image={ceoImage}
                alt={ceoImage.title || 'Avatar'}
                sizes="(max-width: 767px) 59px, (max-width: 991px) 90px, 102px"
              />
            ) : undefined
          }
        />
      </div>
      <div className={styles.textContainer}>
        <p className={styles.quote}>
          "Als Geschäftsführer stehe ich persönlich für die hohe Qualität
          unserer Produkte und die Expertise unserer Mitarbeiter ein."
        </p>
        <span>STEFAN APPELHANS,</span>
        <span>Geschäftsführer</span>
      </div>
    </div>
  );
};
